import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginator } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { customerGroupsService } from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.service'
import { PaginatorDatasource } from '@/shared/resources/datasources/paginator/paginator-datasource'
import { CustomerGroupResponse } from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'

export const columnsDefCustomerGroupsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.groupOfClient'),
            field: 'name',
            minWidth: 250,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export enum CustomerGroupsGridSidepanelComboElements {
    CLIENTS = 1
}

export interface CustomerGroupsGridState extends CrudModelPaginator<CustomerGroupResponse> {
    service: typeof customerGroupsService
}
export const initialCustomerGroupsGridState =
    (): CustomerGroupsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.accounting.customerGroups',
        columnsDef: columnsDefCustomerGroupsGrid(),
        datasource: new PaginatorDatasource(customerGroupsService),
        service: customerGroupsService,
        visibleSidePanel: false
    })
